/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfBoolean } from '../../models/platform-api-result-of-boolean';
import { PlatformForceInvalidateUser } from '../../models/platform-force-invalidate-user';

export interface PostUserpresenceActionForceinvalidateuser$Params {
      body: PlatformForceInvalidateUser
}

export function postUserpresenceActionForceinvalidateuser(http: HttpClient, rootUrl: string, params: PostUserpresenceActionForceinvalidateuser$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
  const rb = new RequestBuilder(rootUrl, postUserpresenceActionForceinvalidateuser.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfBoolean>;
    })
  );
}

postUserpresenceActionForceinvalidateuser.PATH = '/api/userpresence/action/forceinvalidateuser';
